import React from 'react'

import { HeadingXSmall } from '@pb/components'
import { path } from 'ramda'
import { useFormContext } from 'react-hook-form'

import styles from './ErrorMessage.module.scss'

const ErrorMessage: React.FC<any> = ({ name }) => {
  const { errors = {} } = useFormContext()
  const errorMessage: any = path([name, 'message'], errors)

  if (!errorMessage) {
    return null
  }

  return (
    <HeadingXSmall className={styles.errorMessage} Tag="span" role="log" aria-live="polite">
      {errorMessage}
    </HeadingXSmall>
  )
}

export default ErrorMessage
